import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
    _setArsonist,
    _setDateOfBirth,
  _setDeployedCombatDuty,
  _setDiagnosedPostTraumaticStressDisorder,
  _setEthnicityOrRace,
  _setFirstName,
  _setGender,
  _setLastName,
  _setMiddleName,
  _setRegistration290,
  _setSSN,
  _setSuffix,
  _setVeteran,
} from './addParticipantAction';
import initialState from './addParticipantInitialData';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAddParticipantFormSlice = createAsyncThunk(
  'stop/getAddParticipantFormSlice',
  async (params) => {
    const { url, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(url, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const addParticipantFormSlice = createSlice({
  name: 'stop/addParticipantFormSlice',
  initialState,
  reducers: {
    setLastName: _setLastName,
    setFirstName: _setFirstName,
    setMiddleName: _setMiddleName,
    setSSN: _setSSN,
    setDateOfBirth: _setDateOfBirth,
    setSuffix: _setSuffix,
    setGender: _setGender,
    setEthnicityOrRace: _setEthnicityOrRace,
    setVeteran: _setVeteran,
    setDeployedCombatDuty: _setDeployedCombatDuty,
    setDiagnosedPostTraumaticStressDisorder: _setDiagnosedPostTraumaticStressDisorder,
    setRegistration290: _setRegistration290,
    setArsonist: _setArsonist,
    newParticipant: (state, action) => action.payload,
    resetAddParticipant: () => null,
  },
  extraReducers: {
    [getAddParticipantFormSlice.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setLastName,
  setFirstName,
  setMiddleName,
  setSSN,
  setDateOfBirth,
  setSuffix,
  setGender,
  setEthnicityOrRace,
  setVeteran,
  setDeployedCombatDuty,
  setDiagnosedPostTraumaticStressDisorder,
  setRegistration290,
  setArsonist,
  newParticipant,
  resetAddParticipant,
} = addParticipantFormSlice.actions;

export default addParticipantFormSlice.reducer;
